import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { checkBrowserCompatibility, getBrowserInfo } from '../utils/browserCompatibility';

export function BrowserCompatibilityCheck({ children }: { children: React.ReactNode }) {
  const compatibility = checkBrowserCompatibility();
  const browserInfo = getBrowserInfo();
  
  if (!compatibility.supported) {
    return (
      <div className="min-h-screen bg-theme-bg-primary text-theme-text-primary flex items-center justify-center p-4">
        <div className="max-w-2xl w-full bg-theme-bg-secondary rounded-lg p-8">
          <div className="flex items-center gap-3 mb-4">
            <AlertTriangle className="w-8 h-8 text-theme-warning" />
            <h1 className="text-2xl font-bold">Browser Compatibility Issue</h1>
          </div>

          <p className="text-theme-text-secondary mb-4">
            {compatibility.message}
          </p>

          <div className="bg-theme-bg-tertiary rounded p-4 mb-6">
            <p className="text-sm text-theme-text-muted">
              Detected Browser: {browserInfo.name} {browserInfo.version}
            </p>
          </div>

          <div className="space-y-2">
            <h2 className="text-lg font-semibold text-theme-text-primary">Recommended Browsers:</h2>
            <ul className="list-disc list-inside text-theme-text-secondary space-y-1">
              <li>Chrome 80 or later</li>
              <li>Firefox 75 or later</li>
              <li>Safari 13 or later</li>
              <li>Edge 80 or later</li>
            </ul>
          </div>

          <div className="mt-6 p-4 bg-theme-warning/10 border border-theme-warning rounded">
            <p className="text-sm text-theme-warning">
              You can try to continue anyway, but the application may not work correctly.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-3 px-4 py-2 bg-theme-warning hover:bg-theme-warning/80 text-white rounded transition-colors"
            >
              Continue Anyway
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
}